/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { connect } from "react-redux";
import order from "../../../../models/order";
import validate from "../../../../models/validate";
let $ = window.$;

class OutOfStock extends React.Component {
  state = {
    email: ""
  };
  handleChange(e) {
    this.props.setEmailValidateInit();
    this.setState({
      email: e.target.value
    });
  }
  handleClick(email) {
    const { sendEmail } = this.props;
    sendEmail(email);
    $(".outOfStockFormFin_wrap").fadeIn();
  }
  withValidateEmail(email, fn) {
    var rule = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$");
    if (email === "") {
      this.props.setEmailEmpty();
      return null;
    }
    if (!rule.test(email)) {
      this.props.setEmailCheckFailed();
      return null;
    }
    fn();
  }
  render() {
    return (
      <>
        <input
          type="text"
          className="float-left"
          id="outOfStock_email"
          name="outOfStock_email"
          required
          minLength="5"
          maxLength="254"
          placeholder="請在此填上電郵地址我們再與您聯絡。"
          value={this.state.email}
          onChange={this.handleChange.bind(this)}
        />
        <div className="float-right">
          <a
            className="outOfStock_submit_btn icon-submit"
            onClick={() =>
              this.withValidateEmail(this.state.email, () =>
                this.handleClick(this.state.email)
              )
            }
          >
            {}
          </a>
        </div>
        <div className="outOfStockFormFin_wrap">
          多謝您的査詢,我們將稍後與您聯絡。
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    maxQuantity: state.product.quantity
  };
};
const mapDispatchToProps = () => {
  return {
    sendEmail: email => order.actions.sendEmail(email),
    setEmailEmpty: () => validate.actions.setEmailEmpty(),
    setEmailCheckFailed: () => validate.actions.setEmailCheckFailed(),
    setEmailValidateInit: () => validate.actions.setEmailValidateInit()
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutOfStock);
